// The 27 EU member states, as ISO 3166 alpha-2 codes.
export const EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];

// Where a merchant can be based when signing up.
export const SIGNUP_COUNTRIES = ['US', 'CA', 'AU', 'GB', ...EU_COUNTRIES];

export const SIGNUP_CURRENCIES = ['USD', 'CAD', 'EUR', 'GBP', 'AUD'];

// The currency a merchant in that country most likely sells in. They can change it.
export const defaultCurrencyFor = (country) => {
    if (country === 'CA') return 'CAD';
    if (country === 'AU') return 'AUD';
    if (country === 'GB') return 'GBP';
    if (EU_COUNTRIES.includes(country)) return 'EUR';
    return 'USD';
};

// Countries whose addresses always carry a state or province.
const COUNTRIES_REQUIRING_REGION = ['US', 'CA', 'AU'];

export const requiresRegion = (country) => COUNTRIES_REQUIRING_REGION.includes(country);

export const regionLabelFor = (country) => {
    if (country === 'US' || country === 'AU') return 'State';
    if (country === 'CA') return 'Province';
    return 'Region';
};

export const postalCodeLabelFor = (country) => {
    if (country === 'US') return 'Zip code';
    if (country === 'AU' || country === 'GB') return 'Postcode';
    return 'Postal code';
};
